import React from 'react';
import styled from 'styled-components';
import chroma from 'chroma-js';
import { lightGrey1Color, busyBackground } from 'js/config/style';
import MiniText from 'js/components/core/MiniText';

const buttonColor = chroma('#efefef');

export default styled(({ isLoading, ...rest }) => <MiniText {...rest} />)`
  line-height: 2.5rem;
  text-align: center;
  cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};
  user-select: none;
  border-top: 1px solid ${lightGrey1Color};
  font-size: 0.8rem;

  ${({ isLoading }) => isLoading && busyBackground(buttonColor)}

  &:hover {
    background: ${lightGrey1Color};
    ${({ isLoading }) => isLoading && busyBackground(buttonColor)}
  }

  &:active {
    background: ${lightGrey1Color.darken(0.1)};
  }
`;
